import { agroApi } from "../api";
import { EntDepMechReportPayload } from "../../../models/departmentMechReport";
import { BlobResponse } from "../../../models/report";

export const reportDepartamentMechApi = agroApi.injectEndpoints({
    endpoints: (builder) => ({

        getReportByMts: builder.mutation<BlobResponse, EntDepMechReportPayload>({
            query: (body) => ({
                url: "/departments/mechanization/report/mts",
                method: "POST",
                body,
                responseHandler: (response) => response.blob(),
            }),
        }),
        getReportByLeasing: builder.mutation<BlobResponse, EntDepMechReportPayload>({
            query: (body) => ({
                url: "/departments/mechanization/report/leasing",
                method: 'POST',
                body,
                responseHandler: (response) => response.blob(),
            })
        }),
        getReportByCooperatives: builder.mutation<BlobResponse, EntDepMechReportPayload>({
            query: (body) => ({
                url: "/departments/mechanization/report/cooperatives",
                method: "POST",
                body,
                responseHandler: (response) => response.blob(),
            })
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetReportByMtsMutation,
    useGetReportByLeasingMutation,
    useGetReportByCooperativesMutation
} = reportDepartamentMechApi;

